import React from 'react';
import { Button, Divider, IconButton, Modal, Paper, Stack, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export default function RoleDeleteDialog({ open, onClose, onSubmit, roleData, isDeleting }) {
  const { settings } = useTranslatedMessages();
  const team = settings.team ?? {};
  const deleteRole = team.delete_role ?? {};
  const title = deleteRole.title || 'Delete Role?';
  const confirmMessage =
    deleteRole.message || 'Deleting this role will remove its permissions from users assigned to it.';

  const deleteButtonLabel = deleteRole.delete_button || 'Delete';
  const cancelLabel = settings.dialogs?.cancel || 'Cancel';

  return (
    <Modal open={open} onClose={onClose}>
      <Paper
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          p: 2,
          outline: 'none',
        }}
      >
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">{title}</Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Stack>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body1" sx={{ my: 2 }}>
          {confirmMessage}
        </Typography>
        <Stack direction="row" sx={{ justifyContent: 'flex-end', gap: 1 }}>
          <Button onClick={onClose} disabled={isDeleting}>
            {cancelLabel}
          </Button>
          <Button variant="contained" color="error" onClick={onSubmit} disabled={isDeleting}>
            {deleteButtonLabel}
          </Button>
        </Stack>
      </Paper>
    </Modal>
  );
}
